import * as React from "react";
import clsx from "clsx";
import { useRouter } from "next/router";
import Num2persian from "num2persian";
import { useDispatch, useSelector } from "react-redux";

import {
  Dialog,
  Slide,
  Grid,
  Typography,
  IconButton,
  makeStyles,
  Container,
  useTheme,
  CircularProgress,
  Button,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { newConvertPersianDigitsToEnglish } from "../../../../../helpers/validators";
import { me } from "../../../../../redux/slices/me";
import { setLogin } from "../../../../../redux/slices/publicSlice";
import RoundedSelectBox from "../../../../common/selectBox/RoundedSelectBox";
import RoundedTextField from "../../../../common/textfield/RoundedTextField";
import WalletUseingComponent from "../../../../common/walletUseingComponent/WalletUseingComponent";

import { doInstantPay } from "../../../../../services/AgapeAPI";
import CurrencyFormat from "../../../../../services/CurrencyFormat";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiDialog-paper": {
      margin: "0 !important",
      borderRadius: "21px",
    },
    "& .MuiDialog-paperFullWidth": {
      width: "90%",
      borderRadius: "21px",
      maxWidth: 400,
    },
  },
  closeIcon: {
    fontSize: "1.818rem",
  },
  container: {
    width: "100%",
    borderRadius: "21px",
    border: "1px solid #dadada",
  },
  real__root: {
    height: "100%",
    paddingBottom: 20,
  },
  padding: {
    padding: "10px 0",
  },
  row: {
    backgroundColor: "#ffffff",
    "& *": {
      fontSize: "2.181rem",
    },
  },
  closeRow: {
    height: "50px",
    backgroundColor: "#ffffff",
    borderRadius: "21px 21px 0 0",
  },
  paymentField: {
    fontWeight: "500",
  },
  textCurrency: {
    height: "fit-content",
    maxWidth: "97.64%",
    margin: "0 auto",
    transform: "translateY(-20px)",
    "& *": {
      fontSize: "0.909rem",
      fontFamily: "Vazir-Light",
      color: "#acacac",
    },
  },
  instantSupportBtn: {
    position: "relative",
    borderRadius: "29px !important",
    height: "20px !important",
  },

  subjectSelector: {
    marginTop: "15px",
    marginBottom: "5px",
  },

  itemContainer: {
    padding: "0 20px",
  },
  priceBtn: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    borderRadius: "20px",

    border: `1px solid ${theme.palette.landing.light}`,
    padding: "0 5px !important",
    height: "30px !important",
    "&:hover": {
      transform: "none",
    },
    "& *": {
      color: theme.palette.landing.light,
    },
  },
  currency: {
    fontSize: "1.181rem !important",
  },
  donateValue: {
    fontSize: "14px !important",
    width: "100%",
    textAlign: "center",
    [theme.breakpoints.down("md")]: {
      fontSize: "12px !important",
    },
  },
  activeTab: {
    backgroundColor: theme.palette.landing.main,
    "& *": {
      color: "white",
    },
    "&:hover": {
      backgroundColor: theme.palette.landing.main,
    },
  },
  itemContainer: {
    padding: "0",
  },
  align: {
    color: "#ff1339",
    textAlign: "center",
    fontWeight: "bold",
    fontSize: "14px",
    marginTop: 5,
  },
}));

const numbers = /^(|[0-9]\d*)$/;

const OrganizationPaymentDialog = ({ open, setOpen, data }) => {
  const DEFAULT_VALUES = [
    { value: 50000, label: "50 هزار تومان" },
    { value: 100000, label: "100 هزار تومان" },
    { value: 200000, label: "200 هزار تومان" },
  ];

  const classes = useStyles();
  const history = useRouter();
  const dispatch = useDispatch();

  const [intent, setIntent] = React.useState(0);
  const [paymentValue, setPaymentValue] = React.useState(50000);

  const handleClose = () => {
    setOpen(false);
  };

  const setIsLoginOpen = (payload) => {
    dispatch(setLogin(payload));
  };

  const user = useSelector(me);

  const handleBtnClicked = (e) => {
    setPaymentValue(e);
  };

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      scroll="paper"
      fullWidth
      onClose={handleClose}
      className={classes.root}
    >
      <Grid container className={classes.container}>
        <Grid
          item
          container
          xs={12}
          sm={12}
          md={12}
          justifyContent="flex-start"
          className={classes.closeRow}
        >
          <IconButton onClick={handleClose}>
            <CloseIcon className={classes.closeIcon} />
          </IconButton>
        </Grid>
        <Container className={classes.real__root}>
          <Grid item xs={12} sm={12} className={classes.padding}>
            <Grid container>
              {DEFAULT_VALUES.map((item) => (
                <Grid item xs={4} style={{ padding: 5 }} key={item.value}>
                  <Button
                    variant="outlined"
                    fullWidth
                    onClick={() => handleBtnClicked(item.value)}
                    className={clsx(
                      classes.priceBtn,
                      paymentValue === item.value && classes.activeTab
                    )}
                  >
                    <Typography variant="h5" className={classes.donateValue}>
                      {item.label}
                    </Typography>
                  </Button>
                </Grid>
              ))}
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <RoundedTextField
              name="paymentValue"
              placeholder="مبلغ دلخواه"
              onChange={(e) => {
                const text = e.target.value.replaceAll(",", "");
                const en = newConvertPersianDigitsToEnglish(text);
                if (numbers.test(en)) {
                  setPaymentValue(en);
                }
              }}
              value={CurrencyFormat(paymentValue)}
            />

            <Typography variant="h5" className={classes.align}>
              {Num2persian(paymentValue)} تومان
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} className={classes.padding}>
            <WalletUseingComponent
              paymentData={{
                amount: Number(paymentValue) * 10,
                ...(intent !== null && intent > 0
                  ? { intent_id: intent.toString() }
                  : null),
                organization_id: data?.code,
              }}
              paymentURL="pay/payments"
              amount={paymentValue}
              wallet={user?.wallet?.balance || 0}
              text="حمایت میکنم"
            />
          </Grid>

          <Grid
            item
            container
            md={12}
            className={clsx(classes.itemContainer, classes.subjectSelector)}
          >
            <RoundedSelectBox
              defaultValue={0}
              items={[
                { id: 0, name: "نیت حمایت را انتخاب کنید" },
                ...data.visible_intents,
              ]}
              extraHandler={(e) => setIntent(e)}
            />
          </Grid>
        </Container>
      </Grid>
    </Dialog>
  );
};

export default OrganizationPaymentDialog;
